<template>
  <div v-if="componentReady" class="container-wrapper">
    <BackLink :text="backLinkText" />

    <section class="container policy-page">
      <h1 class="policy-page__title">{{ title }}</h1>
      <p class="policy-page__content" v-html="content" />
    </section>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import BackLink from '@/components/BackLink.vue'

  export default {
    name: 'PolicyPage',
    components: {
      BackLink
    },
    data () {
      return {
        title: '',
        backLinkText: '',
        content: '',
        componentReady: false
      }
    },
    async created () {
      const { title, backLinkText, content } = await this.fetchMarketingPageData()
      this.title = title
      this.backLinkText = backLinkText
      this.content = content

      this.componentReady = true
    },
    methods: {
      ...mapActions(['fetchMarketingPageData'])
    }
  }
</script>

<style lang="scss">
  .policy-page {
    &__title {
      margin-right: auto;
      margin-left: auto;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: $c-black;
    }

    h1 {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 44px;
      font-weight: 400;
      line-height: 46px;
      text-transform: uppercase;

      @include mobile {
        font-size: 34px;
        line-height: 1.42;
      }
    }

    h2 {
      font-family: "ToyotaType", Arial, Helvetica, sans-serif;
      font-size: 34px;
      font-weight: 400;
      line-height: 35px;
      text-transform: uppercase;

      @include mobile {
        font-size: 22px;
        line-height: 1.5;
      }
    }

    h3 {
      font-family: "ToyotaType-Semibold", Arial, Helvetica, sans-serif;
      font-size: 22px;
      font-weight: 400;
      line-height: 28px;

      @include mobile {
        font-size: 16px;
      }
    }

    h4 {
      font-family: "ToyotaType", Arial, Helvetica, sans-serif;
      font-size: 22px;
      font-weight: 400;
      line-height: 1.33;

      @include mobile {
        font-size: 16px;
      }
    }

    h5,
    h6 {
      font-family: "ToyotaType-Semibold", Arial, Helvetica, sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 1.35;
    }

    p,
    .p {
      font-weight: 300;
    }

    strong {
      font-family: "ToyotaType-Semibold", Arial, Helvetica, sans-serif;
      font-weight: 700;
    }
  }
</style>
